export const requiredFieldMessage = 'To pole jest wymagane.';
export const requiredMultipleFieldsMessage = 'Wymagane jest uzupełnienie wszystkich pól.';
export const emptyFileInputMessage = 'Pole wyboru pliku zostało dodane lecz nieuzupełnione.';
export const duplicateFileMessage = 'Plik o tej nazwie został już dodany.';
export const phoneNumberFormatError = 'Wpisany numer jest nieprawidłowy.';
export const emailFormatError = 'Wpisany email jest nieprawidłowy.';
